import { ThemeUIStyleObject } from 'theme-ui';

export const pageStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/100',
  minHeight: 'calc(100vh - 4rem)',
  flexDirection: 'column',
};

export const contentStyles: ThemeUIStyleObject = {
  flex: 1,
  width: '100%',
  maxWidth: '900px',
  margin: '0 auto',
  padding: ['1rem', '2rem 5rem'],
};

export const headerTextStyles: ThemeUIStyleObject = {
  marginBottom: 4,
};

export const titleStyles: ThemeUIStyleObject = {
  marginBottom: 2,
};

export const subtitleStyles: ThemeUIStyleObject = {
  color: 'neutral/600',
};

export const cardStyles: ThemeUIStyleObject = {
  marginBottom: 4,
};

export const errorStyles: ThemeUIStyleObject = {
  marginTop: 3,
  padding: 3,
  backgroundColor: 'error/10',
  borderRadius: 'medium',
  borderLeft: '4px solid',
  borderLeftColor: 'error',
  color: 'error',
};
